
import isEmpty from 'lodash/isEmpty'

import { createObserver } from '@core/helpers/vue-Intersection-observer'
import { trackVideoImpression } from '@tracking/events'

export default {
  props: {
    fullscreen: {
      type: Boolean,
      default: false,
    },
    thumbnail: {
      type: Object,
      default: () => ({}),
    },
    trackImpression: {
      type: Boolean,
      default: true,
    },
    tracking: {
      type: Object,
      default: () => ({}),
    },
    video: {
      type: Object,
      required: true,
    },
  },

  computed: {
    attributes() {
      return this.fullscreen
        ? { autoplay: 'autoplay', controls: 'controls' }
        : { loop: 'loop' }
    },
    hasThumbnail() {
      return !isEmpty(this.thumbnail)
    },
  },

  destroyed() {
    this.unobserve()
  },

  mounted() {
    this.watchVideoInViewport()
  },

  methods: {
    watchVideoInViewport() {
      this.unobserve = createObserver(this.$el, () => {
        if (this.trackImpression) {
          trackVideoImpression(this.tracking)
        }
      })
    },
  },
}
